import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Observer } from 'rxjs';
import { delayWhen, flatMap, take } from 'rxjs/operators';
import { IFocusPayload } from 'Src/ng2/store/actions/focus-actions/focus-actions';
import { LoadFocus } from './../../../../store/actions/focus-actions/focus-actions';
import { getFocusData, getFocusLoadedStatus } from './../../../../store/selectors/focus-selectors/focus-selectors';

@Injectable()
export class FocusDataService {
  constructor(public store: Store<any>) {}

  getFocusData$(focusPayload: IFocusPayload): Observable<any> {
    return this.store.select(getFocusLoadedStatus).pipe(
      delayWhen((loaded: boolean) => this.loadFocus$(loaded, focusPayload)),
      flatMap(() => this.store.select(getFocusData)),
      take(1),
    );
  }

  loadFocus$(loaded: boolean, focusPayload: IFocusPayload): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      if (!loaded) {
        this.store.dispatch(new LoadFocus(focusPayload));
      } else {
        observer.next('loading focus');
        observer.complete();
      }
    });
  }
}
